import React from "react";
import { message } from "antd";
import type { UploadProps } from "antd";
import Dragger from "antd/es/upload/Dragger";
import { SvgIcons } from "Icon/SvgIcons";

interface UploadFileProps {
    primaryText?: string;
    secText?: string;
    className?: string;
    setFileData: React.Dispatch<React.SetStateAction<any>>;
}

const UploadFile: React.FC<UploadFileProps> = ({primaryText = "Click to upload", secText = "Csv (max. 1Mb)", className, setFileData}) => {
  

  const handleChange: UploadProps["onChange"] = (info) => {
    const { status } = info.file;
    if (status !== "uploading") {
      console.log("Selected File:", info.file, info.fileList);
    }

    if (status === "done") {
      message.success(`${info.file.name} file uploaded successfully.`);
    } else if (status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }

    // Extract file binary data
    if (info.file.originFileObj) {
      setFileData(info.file.originFileObj);
    }
  };

  const props: UploadProps = {
    name: "file",
    multiple: false,
    beforeUpload: (file) => {
      setFileData(file); // Store the selected file
      return false; // Prevent default upload behavior
    },
    onChange: handleChange,
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  return (
    <div className="pb-4 w-full b">
      <Dragger
        {...props}
        className={`bg-white hover:border-border-theme border-solid ${className}`}
        style={{
          borderStyle: "solid",
          background:'white',
        }}
        maxCount={1}
      >
        <p className="ant-upload-drag-icon mx-auto text-center">
          <span className="w-max inline-flex">{SvgIcons.uploadSvg}</span>
        </p>
        <p className="text-text-tertiary text-sm">
          <strong className="text-primary font-semibold">{primaryText}</strong> or drag and drop
        </p>
        <p className="text-text-tertiary text-sm font-normal">{secText}</p>
      </Dragger>
    </div>
  );
};

export default UploadFile;
